export default "images/bg2.png";